import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import content from 'Content/content.json';
import { language } from 'Root/constants';
import Context from '../../../context';
import Summary from './summary';
import Recommended from './recommended';
import './Result.scss';

const Result = ({ resultType, history }) => {
  const resultsData = content.data.quizResults[language];
  const allLenses = content.data.productInfo[language];

  const context = useContext(Context);
  const [result, setResult] = useState([]);
  const [active, setActive] = useState('');

  useEffect(() => {
    const filteredData = resultsData.filter((data) => data.type === resultType);
    setResult(filteredData);
    setActive(filteredData[0]['recommendations'][0]['key']);
  }, [resultType]);

  const handleQuizSubmit = (recommended) => {
    const lensType = Object.keys(allLenses);
    const activeLens = recommended.filter((lens) => lens.key === active);
    const activeLens_selectedLensType_id = lensType.findIndex((v)=>(v == activeLens[0].selectedLensType));
    const lenses = allLenses[activeLens[0].selectedLensType];
    let activeLensIndex,
      otherItemIndex = -1;
    activeLensIndex = lenses.findIndex((lens) => (lens.key === active));

    const otherItem = recommended.filter((item) => item.key !== active && item.selectedLensType == activeLens[0].selectedLensType);
    if (otherItem.length >= 1 ) {
      otherItemIndex = lenses.findIndex(
        (lens) => (lens.key === otherItem[0]['key'])
      );
    }

    context.updateRecommendation(activeLensIndex, otherItemIndex);
    history.push({
      pathname: `/vm/${activeLensIndex}_${otherItemIndex}_${activeLens_selectedLensType_id}`,
      state: { from: 'quiz' },
    });
  };
  return (
    result &&
    result.map((item) => (
      <div
        key={item.type}
        className={`result-section result-type-${resultType.toLowerCase()}`}
      >
        <Summary img={item.img} name={item.name} desc={item.desc} />
        <Recommended
          recommendations={item.recommendations}
          onSubmit={handleQuizSubmit}
          onSelect={setActive}
        />
      </div>
    ))
  );
};

export default withRouter(Result);
